export default "__VITE_ASSET__BGIgd5bP__"